import { JobCategory } from '@/lib/types/job';

/**
 * Maps product category names to valid job categories that match the database check constraint.
 * This ensures compatibility between product categories and the specifications table category field.
 * 
 * @param productCategoryName - The name of the product category (e.g., "Merchandise", "Print Materials")
 * @returns A valid JobCategory value that matches the database constraint
 */
export function mapProductCategoryToJobCategory(productCategoryName: string): JobCategory {
  const normalized = productCategoryName.toLowerCase().trim();
  
  // Direct mapping for known categories
  const categoryMap: Record<string, JobCategory> = {
    'print materials': 'print_materials',
    'print': 'print_materials',
    'printing': 'print_materials',
    'packaging': 'packaging',
    'signage': 'signage',
    'sign': 'signage',
    'signs': 'signage',
    'merchandise': 'merchandising',
    'merchandising': 'merchandising',
    'promotional': 'merchandising',
    'promotional merchandise': 'merchandising',
  };
  
  // Try direct match
  if (categoryMap[normalized]) {
    return categoryMap[normalized];
  }
  
  // Try partial matches for flexibility
  for (const [key, value] of Object.entries(categoryMap)) {
    if (normalized.includes(key) || key.includes(normalized)) {
      return value;
    }
  }
  
  // Default to 'other' if no match is found
  return 'other';
}
